import { render, staticRenderFns } from "./DonutExample.vue?vue&type=template&id=257f50a2&"
import script from "./DonutExample.vue?vue&type=script&lang=js&"
export * from "./DonutExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports